<div class="modal-body">
  <form [formGroup]="form">
    <div class="row">
      @if (mode === 'create') {
        <rask-input class="col-6 mt-0"
          label="Certifikatsnummer"
          formControlName="certifikatsnummer">
        </rask-input>
        <rask-simple-selector class="col-6 mt-0"
          label="Certifikatstyp"
          formControlName="certifikatstyp"
          [values]="certifikatstyper">
        </rask-simple-selector>
      } @else {
        <rask-input class="col-6 mt-0"
          [disabled]="true"
          label="Certifikatsnummer"
          [value]="certifikat.certifikatsnummer">
        </rask-input>
        <rask-simple-selector class="col-6 mt-0"
          [disabled]="true"
          label="Certifikatstyp"
          [values]="certifikatstyper"
          [value]="certifikat.certifikatstyp">
        </rask-simple-selector>
      }
    </div>

    <div class="row">
      <rask-input class="col-6"
        label="Ägare"
        formControlName="agare">
      </rask-input>
      <rask-datepicker class="col-6"
        formControlName="giltigTom"
        label="Giltig t.o.m">
      </rask-datepicker>
    </div>

    <div class="row">
      <rask-radiobutton-group class="col-6"
        [buttons]="radioButtonOptions"
        label="Sveaskog"
        formControlName="sveaskog">
      </rask-radiobutton-group>
      <rask-radiobutton-group class="col-6"
        [buttons]="radioButtonOptions"
        label="Aktiv"
        formControlName="aktiv">
      </rask-radiobutton-group>
    </div>
  </form>
</div>
<div class="modal-footer">
  <rask-save-button (click)="onSave()">
    Spara
  </rask-save-button>
  <rask-button color="secondary"
    (click)="onCancel()"
    ngbAutofocus>
    Avbryt
  </rask-button>
</div>